import React, { useEffect, FC } from "react"
import { withRouter, match } from "react-router-dom"
import PlaylistItem from "./PlaylistItem"
import { connect } from "react-redux"
import MultiCard from "../../cards/MultiCard"
import { RootState } from "../../../store/reducers"
import { Playlist as PlaylistModel } from "../../../models/playlist"

interface Props<Params extends { id: string } = { id: string }> {
  history: any
  location: any
  match: match<Params>
  staticContext?: any
}

const Playlist: FC<
  Props & {
    playlists: PlaylistModel[]
  }
> = ({
  match: {
    params: { id },
  },
  playlists,
}) => {
  const playlist = playlists.find((p) => p.id === id)

  useEffect(() => {
    document.getElementsByTagName("title")[0].innerHTML =
      playlist !== undefined ? playlist.title : `playlist not found`
  })

  return (
    <div className="app-view">
      <div className="app-view-body" id="playlist">
        {/* <h4 className="app-text">Playlists</h4> */}
        <div className="list">
          {playlist ? (
            playlist && <PlaylistItem playlist={playlist} />
          ) : (
            <div>
              <h4>
                <small>
                  Ooops, we could not find the playlist you looking for
                </small>
              </h4>
              <button
                className="uk-button"
                uk-toggle="target: #playlists-modal"
              >
                Create playlist
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {playlists &&
                playlists.map((a, i) => <MultiCard playlist={a} key={i} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  // playlists: state.playlist.playlists
  playlists: state.data.playlists,
})

export default withRouter(connect(mapStateToProps)(Playlist))
